'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var MEASUREMENTS_STORE_NAME = exports.MEASUREMENTS_STORE_NAME = 'measurementsStore';

// Action Types
var MEASUREMENT_SET = exports.MEASUREMENT_SET = 'MEASUREMENT_SET';
var MEASUREMENT_REMOVE = exports.MEASUREMENT_REMOVE = 'MEASUREMENT_REMOVE';

var BULK_MEASUREMENT_ACTIONS = exports.BULK_MEASUREMENT_ACTIONS = [MEASUREMENT_SET, MEASUREMENT_REMOVE];


//////////////////
// WEBPACK FOOTER
// ./src/client/components/measurements/measurementsConstants.js
// module id = 231
// module chunks = 0